export default "__VITE_ASSET__2c54da3f__"